import React from 'react';
import { CARD_TYPE } from 'tags/models/schemas';
import { CardType, Tag, TagsFilters } from 'tags/models/tags';

export type TagContextProps = {
  type: CardType;
  fetchTags: (filters?: TagsFilters) => Promise<Tag[]>;
  fetchTag: (id: string) => Promise<Tag>;
  fetchAssignedTags: (id: string) => Promise<Tag[]>;
  assignTags: (id: string, selectedValues: string[]) => Promise<void>;
  createTag: (name: string) => Promise<Tag>;
  isProduct?: boolean;
};

export const TagContext = React.createContext<TagContextProps>({
  type: CARD_TYPE.SIM,
  fetchTag: () => {
    throw new Error('not implemented');
  },
  fetchTags: () => {
    throw new Error('not implemented');
  },
  fetchAssignedTags: () => {
    throw new Error('not implemented');
  },
  assignTags: (_id: string, _selectedValues: string[]) => {
    throw new Error('not implemented');
  },
  createTag: () => {
    throw new Error('not implemented');
  },
  isProduct: false,
});
